import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { useI18n } from '../i18n';
import { FormImageUpload } from './Image/FormImageUpload';
export function FormImage({ name, validation, label, helperText, value: fieldValue, onChange: imageOnChange, ...rest }) {
    const { $t } = useI18n();
    const { control, setError } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, render: ({ field: { onChange, value }, fieldState: { error, invalid }, }) => {
            return (_jsxs("div", { children: [label ? (_jsx(FormControl.Label, { htmlFor: name, children: label }, void 0)) : null, _jsxs("div", { className: "mt-1", children: [_jsx(FormImageUpload, { ...rest, value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : value, onChange: value => {
                                    onChange(value);
                                    if (typeof imageOnChange === 'function') {
                                        imageOnChange(value);
                                    }
                                }, onError: ({ message, fileName }) => {
                                    setError(name, {
                                        type: 'validate',
                                        message: fileName
                                            ? $t({
                                                id: 'Generics.UploadFailedWithMessage',
                                                defaultMessage: 'Could not upload {file_name}: {err_message}',
                                            }, { file_name: fileName, err_message: message })
                                            : message,
                                    });
                                } }, void 0), _jsx(FormControl.Meta, { ...{
                                    helperText,
                                    invalid,
                                    error: error === null || error === void 0 ? void 0 : error.message,
                                } }, void 0)] }, void 0)] }, void 0));
        } }, void 0));
}
//# sourceMappingURL=FormImage.js.map